import React from "react";
import "@/animations/animate.css";

import AnimatedElements from "@/animations/AnimatedElement";
import { motion, useScroll, useSpring, useTransform } from 'framer-motion';
import AnimatedBody from "@/animations/AnimatedBody";
import MoonLotties from "./lottie";
import AnimatedLetters from "@/animations/AnimatedLetters";
import { Ivy } from "@/fonts/spaceGrotesk";
import MoonPhases from "./moonphases";

const Moon = ({certificate } : any ) => {
    const ref = React.useRef(null)
    const { scrollYProgress } = useScroll({
        target: ref,
        offset: ["start end", "100vh"]
    
    })
  
    const transform = useTransform(
      scrollYProgress,
      [0, 1],
      [0,2]
    )
  
  const defaults = {
    "moonRiserTime" : "05:21",
    "moonSetTime": "20:12",
    "moonNadirTime": "24:20",
    "sunriseStr": "05:18",
    "sunsetStr": "19:23",
    "turkishPhase": "Yeni Ay",
    "turkishPhaseDesc": "Ay'ın aydınlık olmayan tarafı Dünya'ya dönüktür. Ay, Dünya'dan açıkça görülemez. Fakat Güneş tutulması süresince görülebilir.",
    "phase": "🌑"
}
    const [result, setResult] = React.useState<any>(defaults);
    // @ts-ignore
const [load , setLoad] = React.useState(false);

    React.useEffect(() => {
    
        async function getdata() {
       
            
            const havadurumu = await fetch(`${process.env.NEXT_PUBLIC_URL}/api/moonsetrise?certificate=${certificate}`);
            const havadurumu2 = await havadurumu.json();
            console.log(havadurumu2)
            setLoad(true)
            setResult(havadurumu2)
        }
    
        getdata();
    
    }
    , [])
  
  
    const physics = { damping: 15, mass: 0.27, stiffness: 55 }
    const scale = useSpring(transform, physics)

    return (
        <>

        <section
            ref={ref}
            className="relative min-h-screen z-10 0 w-screen  items-center justify-center overflow-hidden bg-black bg-cover bg-center pt-16 pb-36 md:pt-20 md:pb-44 lg:pt-20 lg:pb-56"
            id="Moon"
        >
           




            <div className="mx-auto flex w-screen flex-row items-center justify-center lg:max-w-[1212.8px]">
            
            <div className="mx-auto flex w-screen flex-col   ">
                    <div className=" flex w-screen  flex-col  items-center justify-center  text-[18px] font-medium  leading-relaxed tracking-wide text-[#e4ded7]  md:text-[20px] md:leading-relaxed  lg:text-[24px] ">
                 <motion.div 
                 style={
                    {
                        scale
                    }
                 }
                 >   <AnimatedElements>   
                    <MoonLotties />
                      </AnimatedElements>     
                      </motion.div>
                    </div>
                    <AnimatedLetters style={`font-black text-[3.3rem] sm:text-[4.5rem] leading-none items-center justify-center flex flex-col text-center m-0 ${Ivy.className}`}
                    title={result.turkishPhase + ' ' + result.phase} />

                   <div className="w-80 h-80 rounded-full bg-opacity-30 bg-purple-500 blur-3xl absolute top-0 bottom-0 left-0 right-0 mx-auto my-auto"></div>

<AnimatedBody delay={0.2}
                    className="text-[1.5rem] sm:text-[1.9rem] font-normal text-center !text-opacity-100 !text-white-vibrant "
                    text={'Bu evrede ' + result.turkishPhaseDesc }  />

<MoonPhases />
                    
                </div>
                <div className="mx-auto flex w-[100%] flex-col lg:max-w-[1200px] lg:flex-row ">
                    <div className="mb-10 flex w-[100%] flex-col gap-4 text-[18px] font-medium  leading-relaxed tracking-wide text-[#e4ded7] md:mb-16 md:gap-6 md:text-[20px] md:leading-relaxed lg:mb-16  lg:max-w-[90%] lg:text-[24px] ">
                 
                    </div>
                </div>
            </div>
        </section></>
    );
};

export default Moon;
